import { useState, useEffect } from 'react';

const WHATSAPP_NUMBER = '5518997235480';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Olá! Vi o curso de ChatGPT e Gemini para Professores e fiquei com dúvidas. Pode me ajudar?'
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

const DELAY_MS = 8000;

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setShowTooltip(true), 600);
    }, DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed) return null;

  return (
    <div
      className={`fixed bottom-24 right-6 z-50 flex flex-col items-end gap-2 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      {/* Tooltip de recuperação */}
      {showTooltip && (
        <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-4 max-w-[240px] animate-fade-in">
          <button
            onClick={() => setDismissed(true)}
            className="absolute -top-2 -right-2 w-5 h-5 bg-gray-400 hover:bg-gray-600 text-white rounded-full flex items-center justify-center text-xs cursor-pointer transition-colors"
            aria-label="Fechar"
          >
            <i className="ri-close-line text-xs"></i>
          </button>
          <p className="text-gray-800 text-sm font-medium leading-snug">
            🎓 Ficou com dúvida sobre o curso?
          </p>
          <p className="text-gray-500 text-xs mt-1 leading-snug">
            Fale comigo no WhatsApp e tire todas as suas dúvidas agora!
          </p>
          {/* Seta apontando para o botão */}
          <div className="absolute -bottom-2 right-5 w-4 h-4 bg-white border-r border-b border-gray-100 rotate-45"></div>
        </div>
      )}

      {/* Botão WhatsApp */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp"
        className="w-14 h-14 flex items-center justify-center rounded-full shadow-lg cursor-pointer transition-transform hover:scale-110 active:scale-95"
        style={{ backgroundColor: '#25D366' }}
        onClick={() => setShowTooltip(false)}
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>

      {/* Pulso animado */}
      <span
        className="absolute bottom-0 right-0 w-14 h-14 rounded-full animate-ping opacity-30 pointer-events-none"
        style={{ backgroundColor: '#25D366' }}
      ></span>
    </div>
  );
}
